import { Injectable } from '@angular/core';
import { PreflightProductPreviewRequest } from '@gelato-api-ui/core/preflight/preflight-product-preview-request';
import { DesignProductPreviewUrlParams } from '@gelato-api-ui/core/preflight/types/design-product-preview-url-params';
import { PreviewFileType } from '@gelato-api-ui/core/preflight/preview-file-type.enum';

@Injectable({ providedIn: 'root' })
export class PreflightProductPreviewRequestProvider {
  get(
    productUid: string,
    designPreviewUrlParams: DesignProductPreviewUrlParams,
    width: number,
    height: number,
    previewScene: string,
    forceDimensions: boolean,
    previewFileType: PreviewFileType,
  ): PreflightProductPreviewRequest {
    if (!designPreviewUrlParams) {
      return null;
    }

    const request: PreflightProductPreviewRequest = {
      product_uid: productUid,
      force_dimensions: forceDimensions,
      width,
      height,
    };

    if (previewScene) {
      request.scene = previewScene;
    }

    if (previewFileType) {
      request.format = previewFileType;
    }

    if (designPreviewUrlParams.imagesUrls) {
      request.images_urls = JSON.stringify(designPreviewUrlParams.imagesUrls);
    } else if (designPreviewUrlParams.imageUrl) {
      request.image_url = designPreviewUrlParams.imageUrl;
    }

    return request;
  }
}
